module.exports = __webpack_public_path__ + "img/ahu1.c3929159.jpg";